import React, { useState } from 'react';
import { Table, Input, Tag ,Empty,ConfigProvider} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import EmptyData from '../Assets/EmptyData.jpg';

const { Search } = Input;

const initialData = [
 {
    key: '1',
    sno: '01',
    month: 'June',
    mspcname: 'KARWAR',
    jwponumber: '1200',
    jwqty: '200 T',
    totalfg: '7 items',
    dcqty: '20 t',
    dccreated: '00',
    balanceqty: '20 t',
    status: 'Pending',
  },
  {
    key: '1',
    sno: '01',
    month: 'June',
    mspcname: 'KARWAR',
    jwponumber: '1200',
    jwqty: '200 T',
    totalfg: '7 items',
    dcqty: '20 t',
    dccreated: '00',
    balanceqty: '20 t',
    status: 'Pending',
  },
  {
    key: '1',
    sno: '01',
    month: 'June',
    mspcname: 'KARWAR',
    jwponumber: '1200',
    jwqty: '200 T',
    totalfg: '7 items',
    dcqty: '20 t',
    dccreated: '00',
    balanceqty: '20 t',
    status: 'Pending',
  },
  {
    key: '1',
    sno: '01',
    month: 'June',
    mspcname: 'KARWAR',
    jwponumber: '1200',
    jwqty: '200 T',
    totalfg: '7 items',
    dcqty: '20 t',
    dccreated: '00',
    balanceqty: '20 t',
    status: 'Pending',
  },
  {
    key: '1',
    sno: '01',
    month: 'June',
    mspcname: 'KARWAR',
    jwponumber: '1200',
    jwqty: '200 T',
    totalfg: '7 items',
    dcqty: '20 t',
    dccreated: '00',
    balanceqty: '20 t',
    status: 'Pending',
  },
  {
    key: '2',
    sno: '01',
    month: 'June',
    mspcname: 'Ahola',
    jwponumber: '1200',
    jwqty: '200 T',
    totalfg: '3 items',
    dcqty: '200 t',
    dccreated: '03',
    balanceqty: '00 t',
    status: 'Completed',
  },
   { key: '2',
    sno: '01',
    month: 'June',
    mspcname: 'Ahola',
    jwponumber: '1200',
    jwqty: '200 T',
    totalfg: '3 items',
    dcqty: '200 t',
    dccreated: '03',
    balanceqty: '00 t',
    status: 'Completed',
  },
   { key: '2',
    sno: '01',
    month: 'June',
    mspcname: 'Ahola',
    jwponumber: '1200',
    jwqty: '200 T',
    totalfg: '3 items',
    dcqty: '200 t',
    dccreated: '03',
    balanceqty: '00 t',
    status: 'Completed',
  },
  
];

const JobWork_DC = () => {
  const [filteredData, setFilteredData] = useState(initialData);
  const navigate = useNavigate();

  const onSearch = (value) => {
    const filtered = initialData.filter((item) =>
      item.mspcname.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
  };

  
  const columns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      key: 'sno',
    },
    {
      title: 'Month',
      dataIndex: 'month',
      key: 'month',
    },
    {
      title: 'MSPC Name',
      dataIndex: 'mspcname',
      key: 'mspcname',
    },
    {
      title: 'JWPO Number',
      dataIndex: 'jwponumber',
      key: 'jwponumber',
    },
    {
      title: 'JW Qty',
      dataIndex: 'jwqty',
      key: 'jwqty',
    },
    {
      title: 'Total FG',
      dataIndex: 'totalfg',
      key: 'totalfg',
    },
    {
      title: 'DC Qty',
      dataIndex: 'dcqty',
      key: 'dcqty',
    },
    {
      title: 'DC Created',
      dataIndex: 'dccreated',
      key: 'dccreated',
      render: (text, record) =>
        record.status === 'Completed' ? (
          <>
            {text}{' '}
            <a
              href="#"
            
            >
              View DC
            </a>
          </>
        ) : (
          text
        ),
    },
    {
      title: 'Balance Qty',
      dataIndex: 'balanceqty',
      key: 'balanceqty',
    },
   {
  title: 'Status',
  dataIndex: 'status',
  key: 'status',
  render: (status, record) =>
    status === 'Pending' ? (
      <Tag
        color="blue"
        style={{ cursor: 'pointer' }}
        onClick={() => navigate('/jobwork/jobwork_dc/jw_dc')}
      >
        {status}
      </Tag>
    ) : (
      <Tag color="green">{status}</Tag>
    ),
},

  ];

  return (
    <div style={{ padding: '20px' }}>
      <Search
        placeholder="Search By Name or MSPC"
        allowClear
        onSearch={onSearch}
        style={{ width: '50%', marginBottom: 20 }}
        prefix={<SearchOutlined />}
      />
      <ConfigProvider
                    renderEmpty={() => (
                      <Empty
                        image={EmptyData}
                        description="No CategoryMaster Data Available"
                        imageStyle={{ height: 200 }}
                      />
                    )}
                  >
      <Table
        columns={columns}
        dataSource={filteredData}
        pagination={false}
        size="small"
        bordered
      />
      </ConfigProvider>
    </div>
  );
};

export default JobWork_DC;
